export default {"src":"/stays/_next/static/media/discount.a4360ee4.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};